
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionalMessageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionalMessage"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"targetProduct"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingAttributes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricingAttribute1"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingAttributeReferenceFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingAttribute2"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingAttributeReferenceFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingAttribute3"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingAttributeReferenceFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingAttribute4"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingAttributeReferenceFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingAttribute5"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingAttributeReferenceFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingAttribute6"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingAttributeReferenceFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingAttribute7"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingAttributeReferenceFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingAttribute8"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingAttributeReferenceFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingAttribute9"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingAttributeReferenceFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingAttribute10"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingAttributeReferenceFragment"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":1030}};
    doc.loc.source = {"body":"#import 'graphql/fragments/product/PricingAttributeReferenceFragment.graphql'\n\nfragment PromotionalMessageFragment on PromotionalMessage {\n  id\n  concurrencyVersion\n  uuid\n  name\n  targetProduct {\n    id\n    concurrencyVersion\n    reference\n    description\n  }\n  pricingAttributes {\n    pricingAttribute1 {\n      ...PricingAttributeReferenceFragment\n    }\n    pricingAttribute2 {\n      ...PricingAttributeReferenceFragment\n    }\n    pricingAttribute3 {\n      ...PricingAttributeReferenceFragment\n    }\n    pricingAttribute4 {\n      ...PricingAttributeReferenceFragment\n    }\n    pricingAttribute5 {\n      ...PricingAttributeReferenceFragment\n    }\n    pricingAttribute6 {\n      ...PricingAttributeReferenceFragment\n    }\n    pricingAttribute7 {\n      ...PricingAttributeReferenceFragment\n    }\n    pricingAttribute8 {\n      ...PricingAttributeReferenceFragment\n    }\n    pricingAttribute9 {\n      ...PricingAttributeReferenceFragment\n    }\n    pricingAttribute10 {\n      ...PricingAttributeReferenceFragment\n    }\n  }\n  message\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('graphql/fragments/product/PricingAttributeReferenceFragment.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PromotionalMessageFragment"] = oneQuery(doc, "PromotionalMessageFragment");
        
